export default __webpack_public_path__ + "static/media/P20006.ee365085.png";